module.exports = __webpack_public_path__ + "img/97.f9f31803.jpg";